import baguetteBox from 'baguettebox.js';

const lightBoxes = document.querySelectorAll('.lightbox');

if (lightBoxes.length > 0) {
  baguetteBox.run('.lightbox', {
    animation: 'slideIn',
    noScrollbars: true,
    afterHide: () => {
      document.body.removeAttribute('style');
    },
  });
}
